module.exports = __webpack_public_path__ + "static/media/check_small.30bc0138.svg";